import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

// Register scrolling
gsap.registerPlugin(ScrollTrigger);

export default gsap;
